export const cflTeamNameIDArrayMap = new Map([
    [5611, 'hamilton-tiger-cats'],
    [5612, 'montreal-alouettes'],
    [27755, 'ottawa-redblacks'],
    [5615, 'toronto-argonauts'],
    [5608, 'bc-lions'],
    [5609, 'calgary-stampeders'],
    [5610, 'edmonton-elks'],
    [5614, 'saskatchewan-roughriders'],
    [5616, 'winnipeg-blue-bombers'],
])
